import { createContext } from "react";
import { Currency } from "@evennt-tech/api-v2-core";

export const CurrencyContext = createContext<Currency>(Currency.gbp);
